import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target"]

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'IoRouterLink',
  props: {
    linkUrl: {},
    linkTarget: {},
    linkTitle: {},
    active: { type: Boolean },
    customHandler: { type: Function }
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const router = useRouter();

const currentPage = computed(() => store.getters['page/page']);
const isActive = computed(() => props.active || (
  currentPage.value && currentPage.value.url === props.linkUrl
));

const routeParts = props.linkUrl.split(window.location.host);
const routePath = routeParts[routeParts.length - 1];

const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const navigate = (e: Event) => {
  if ([undefined, null, '_self'].indexOf(props.linkTarget) >= 0) {
    e.preventDefault();

    if (typeof props.customHandler === 'function') {
      props.customHandler(() => {
        router.push(routePath).then(() => {
          toTop();
        });
      });
    } else {
      router.push(routePath).then(() => {
        toTop();
      });
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.linkUrl,
    target: _ctx.linkTarget,
    class: _normalizeClass({ 'active': isActive.value }),
    onClick: navigate
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})